import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { EventInteractionService } from '@mare-common/ngx-mare-common';
export interface CtaThankyou {
  text?: string;
  action?:() => void;
  link?: string;
}
export interface ThankyouAction{
  text: string
  value: string;
}
@Component({
  selector: 'ngx-thank-you',
  standalone: true,
  imports: [CommonModule,
    MatButtonModule,
  TranslateModule],
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent {
  @Input() cta?: CtaThankyou;
  @Input() headline?: string;
  @Input() message?: string;
  @Input() related?: Array<any>;
  @Input() orderComplete: boolean = true;
  @Input() product?: string;

  productPurchased:string = 'il servizio';

  @Output() ctaClick = new EventEmitter();

  constructor(private eventInteractionService: EventInteractionService,) { }
  
  ngOnInit(): void { 
    this.productPurchased = this.product ? this.product : 'il servizio';
  }

  ngOnChanges(changes:SimpleChanges): void {
    if(changes['productName']) {
      this.productPurchased = changes['productName'].currentValue;
    }
  }

  ctaAction() {
    if (this.cta?.action) {
      this.cta.action();
    }
    else if (this.cta?.link) {
      this.eventInteractionService.gotoLink(this.cta.link, false);
    } else {
      this.ctaClick.emit('thankyou-cta');
    }
  }
}
